module.exports = __webpack_public_path__ + "img/UI_shouji_BG_03_05b6dd1ec.png";